const DOMAIN_PATTERN = /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i;

export function normalizeHostname(value) {
  return String(value || '').trim().toLowerCase().replace(/\.$/, '');
}

function parseUrlWithFallback(rawUrl) {
  const input = String(rawUrl || '').trim();
  if (!input) {
    return null;
  }
  try {
    return new URL(input);
  } catch (error) {
    try {
      return new URL(`http://${input}`);
    } catch (fallbackError) {
      return null;
    }
  }
}

export function extractHostname(rawUrl) {
  const parsed = parseUrlWithFallback(rawUrl);
  return parsed ? normalizeHostname(parsed.hostname) : '';
}

export function normalizeComparableUrl(rawUrl) {
  const input = String(rawUrl || '').trim();
  if (!input) {
    return '';
  }
  const parsed = parseUrlWithFallback(input);
  if (!parsed) {
    return input.toLowerCase();
  }
  const host = normalizeHostname(parsed.hostname);
  const path = parsed.pathname && parsed.pathname !== '/' ? parsed.pathname.replace(/\/+$/, '') : '';
  const search = parsed.search || '';
  return `${host}${path}${search}`;
}

export function isValidDomain(value) {
  return DOMAIN_PATTERN.test(value);
}

export function normalizeDomainList(domains) {
  const arr = Array.isArray(domains) ? domains : [];
  const normalized = arr
    .map((v) => String(v || '').trim().toLowerCase())
    .filter(Boolean)
    .filter((v) => isValidDomain(v));
  return Array.from(new Set(normalized)).sort((a, b) => a.localeCompare(b));
}

export function safeExternalUrl(rawUrl) {
  const input = String(rawUrl || '').trim();
  if (!input) {
    return '';
  }
  try {
    const parsed = new URL(input);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return parsed.href;
    }
  } catch (error) {
    return '';
  }
  return '';
}
